<template>
  <dx-popup
    :visible="showMe"
    :showTitle="false"
    :drag-enabled="false"
    :height="750"
  >
    <b-form
      class="mt-3 mb-4 pl-3 pb-3 "
      :class="{
        'needs-validation': !submitted,
        'was-validated': submitted
      }"
      novalidate
      ref="f"
    >
      <b-container fluid>
        <h5 class="text-center" v-if="!user.is_internal">
          Account Information
        </h5>
        <b-row>
          <b-col> </b-col>
        </b-row>
        <!-- <hr v-if="!user.is_internal" />
        <b-row>
          <b-col>
            <b-container fluid>
              <b-form-group :label-cols="2" label="Site:" label-align="right">
                <b-select
                  v-model="user.site_id"
                  :options="options"
                  v-if="!user.is_internal"
                  :disabled="sites.length <= 1"
                  required
                ></b-select>
              </b-form-group>
            </b-container>
          </b-col>
        </b-row> -->
        <hr />

        <h5 class="text-center">Personal Information</h5>
        <hr />
        <b-row>
          <b-col>
            <b-form-group
              :label-cols="2"
              label="First Name:"
              label-align="right"
              :invalid-feedback="validationStat.firstName.msg"
            >
              <!-- <b-form-invalid-feedback
                    :state="validationStat.firstName.state"
                  >
                    {{ validationStat.firstName.msg }}
                  </b-form-invalid-feedback> -->
              <b-form-input
                type="text"
                v-model="user.first_name"
                placeholder="Last Name"
                :maxlength="255"
                @blur="trimField"
                :state="validationStat.firstName.state"
                required
                id="fn"
                ref="firstName"
              />
            </b-form-group>
            <b-form-group
              :label-cols="2"
              label="Last Name:"
              label-align="right"
              :invalid-feedback="validationStat.lastName.msg"
            >
              <!-- <b-form-invalid-feedback
                    :state="validationStat.lastName.state"
                  >
                    {{ validationStat.lastName.msg }}
                  </b-form-invalid-feedback> -->
              <b-input
                type="text"
                v-model="user.last_name"
                placeholder="Last Name"
                :maxlength="255"
                @blur="trimField"
                :state="validationStat.lastName.state"
                required
                ref="lastName"
              />
            </b-form-group>

            <b-form-group
              :label-cols="2"
              label="Email:"
              label-align="right"
              :invalid-feedback="validationStat.email.msg"
            >
              <!-- <b-form-invalid-feedback :state="validationStat.email.state">
                    {{ validationStat.email.msg }}
                  </b-form-invalid-feedback> -->
              <b-input
                type="email"
                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                :state="validationStat.email.state"
                v-model="user.email"
                placeholder="user@yourdomain.com"
                @blur="trimField"
                :maxlength="255"
                required
                ref="email"
              />
            </b-form-group>
            <b-form-group
              :label-cols="2"
              label="Password:"
              label-align="right"
              :invalid-feedback="validationStat.password.msg"
            >
              <!-- <b-form-invalid-feedback :state="validationStat.password.state">
                  {{ validationStat.password.msg }}
                </b-form-invalid-feedback> -->
              <b-input
                type="password"
                placeholder="Password"
                v-model="user.password"
                @blur="trimField"
                :maxlength="255"
                :state="validationStat.password.state"
                required
                ref="password"
              />
            </b-form-group>
            <!--
                  <dx-form
                  :form-data="user"
                  :items="formFields"
                />
                -->
          </b-col>
        </b-row>
        <hr />
        <h5 class="text-center" v-if="AuthType === 'ca' || AuthType === 'sa'">
          User Type & Permissions
        </h5>
        <b-row v-if="AuthType === 'sa' || AuthType === 'ca'">
          <b-col>
            <b-container fluid>
              <b-row>
                <b-col>
                  <b-radio-group
                    v-model="user.is_internal"
                    v-if="AuthType === 'sa'"
                    required
                  >
                    <b-radio name="Internal" :value="0">
                      Customer
                    </b-radio>
                    <b-radio name="Internal" :value="1">
                      LINK Document Services Group Internal
                    </b-radio>
                  </b-radio-group>
                  <b-checkbox
                    class="mt-1"
                    @change="setAdmin"
                    :checked="user.is_admin === 1"
                    v-if="AuthType === 'sa' || AuthType === 'ca'"
                  >
                    Administrator
                  </b-checkbox>
                </b-col>
              </b-row>
              <hr />
            </b-container>
          </b-col>
        </b-row>
      </b-container>
      <b-button
        type="submit"
        href="#"
        @click.stop.prevent="onSubmit"
        variant="blue"
        style="width:125px;"
      >
        Save Changes
      </b-button>
      <b-button
        variant="orange"
        @click="$emit('onUserEditorStatChanged', false)"
        style="width:125px;"
      >
        Cancel
      </b-button>
    </b-form>
  </dx-popup>
</template>

<script>
import { confirm } from "devextreme/ui/dialog";

export default {
  props: ["site_id", "display"],
  data() {
    return {
      submitted: false,
      user: null,
      validationStat: {
        site: {
          state: null,
          msg: ""
        },
        firstName: {
          state: null,
          msg: ""
        },
        lastName: {
          state: null,
          msg: ""
        },
        email: {
          state: null,
          msg: ""
        },
        password: {
          state: null,
          msg: ""
        }
        // userType: {
        //   state: null,
        //   msg: ""
        // }
      },
      _showWindow: false
    };
  },
  beforeMount() {
    if (!this.user) {
      this.clear();
    }
  },
  computed: {
    sites() {
      return this.$store.getters["accounts/allSites"];
    },
    currentSite() {
      debugger;
      var site = this.$store.getters["accounts/currentSite"];
      if (!site) {
        site = this.sites.find(s => s.id === this.site_id);
      }

      return site ? site : {};
    },
    AuthType() {
      return this.$store.getters["user/authType"];
    },
    accounts() {
      return this.$store.getters["accounts/accounts"];
    },
    options() {
      var acct = this.accounts ? this.accounts : [];
      var sites = this.sites ? this.sites : [];
      if (acct.length === 0 || sites.length === 0) {
        return [];
      }
      var rsp = [
        {
          value: null,
          text: "Please select a site"
        }
      ];

      acct.forEach(ac => {
        var r = {
          label: ac.name,
          options: []
        };
        var st = sites.filter(s => s.account_id === ac.id);

        st = st ? st : [];

        if (st.length > 0) {
          st.forEach(s => {
            var site = {
              value: s.id,
              text: s.name
            };

            r.options.push(site);
          });
          rsp.push(r);
        }
      });

      return rsp;
    },
    showMe: {
      get() {
        return this.display;
      },
      set(val) {
        this.display = val;
      }
    }
  },
  methods: {
    onSubmit(e) {
      e.preventDefault;
      this.submitted = true;
      this.checkValiation(e.target);

      if (!this.$refs.f.checkValidity()) {
        return;
      }

      this.currentSite.users.push(this.user);
      return this.$store.dispatch("accounts/flagChanges", true).then(() => {
        this.clear();
        this.$emit("onUserEditorStatChanged", false);
      });
    },
    onCancelClick() {
      this.clear();
      this.submitted = false;
      this.$emit("onUserEditorStatChanged", false);
    },
    clear() {
      this.user = {
        first_name: "",
        last_name: "",
        site_id: this.currentSite.id,
        email: "",
        password: "",
        is_admin: 0,
        is_internal: 0
      };
      this.submitted = false;
      this.clearValiation();
    },
    checkValiation() {
      debugger;
      var fields = this.$refs;

      for (var fld in fields) {
        try {
          this.validationStat[fld].state = this.$refs[fld].checkValidity();
          this.validationStat[fld].msg = this.$refs[fld].validationMessage;
        } catch (ex) {
          console.log("Err: ex \n Field: " + fld);
        }
      }
    },
    clearValiation() {
      debugger;
      var fields = this.$refs;

      for (var fld in fields) {
        try {
          this.validationStat[fld].state = null;
          this.validationStat[fld].msg = "";
        } catch (ex) {
          console.log("Err: ex \n Field: " + fld);
        }
      }
    },
    setAdmin(e) {
      this.user.is_admin = e ? 1 : 0;
    },
    onBlur(e) {
      this.trimField(e);
    },
    trimField(e) {
      var str = typeof e.target.value === "string";

      if (str) {
        e.target.value = e.target.value.trim();
      }
    },
    onClose(e) {
      debugger;
      this.$emit("onClose", false);
    }
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/admin/UserEdit.vue